import Side from "./side";

const depth = 15;

export default function Yurt(p5, trait, width, handleTraitChange, wallTrait) {
  this.xcenter = width / 2;
  this.margin = p5.height / 2.2;
  this.size = width / 2.6;
  this.sides = [];

  let increment = (360 / trait.size) * 22;
  let textSize = width / 100;

  for (let a = 0; a < 360; a += 360 / trait.size) {
    if (increment <= 360) {
      increment += 360 / trait.size;
    } else {
      increment = (360 / trait.size) * 2;
    }
    p5.angleMode(p5.DEGREES);
    let side = new Side(
      p5,
      trait,
      this.xcenter,
      this.margin,
      this.size,
      depth,
      increment,
      textSize
    );
    this.sides.push(side);
  }

  if (this.sides.length === 28) {
    this.sides.pop();
  }

  this.render = (p5, wallTrait, editing) => {
    for (let i = 0; i < trait.size; i++) {
      if (wallTrait[i].frenchDoor === "left") {
        const nextIndex = (i, k) => {
          return (
            (((i + k) % this.sides.length) + this.sides.length) %
            this.sides.length
          );
        };
        p5.push();
        p5.strokeWeight(1);
        p5.line(
          this.sides[i].x4,
          this.sides[i].y4,
          this.sides[nextIndex(i, 2)].x5,
          this.sides[nextIndex(i, 2)].y5
        );
        p5.pop();
      }
      if (editing) {
        this.sides[i].textColor = "orange";
      }
      this.sides[i].render(p5, i, wallTrait);
    }
  };

  this.stackEditRender = (p5, wallTrait, stackArray) => {
    for (let i = 0; i < trait.size; i++) {
      if (wallTrait[i].frenchDoor === "left") {
        const nextIndex = (i, k) => {
          return (
            (((i + k) % this.sides.length) + this.sides.length) %
            this.sides.length
          );
        };
        p5.push();
        p5.strokeWeight(1);
        p5.line(
          this.sides[i].x4,
          this.sides[i].y4,
          this.sides[nextIndex(i, 2)].x5,
          this.sides[nextIndex(i, 2)].y5
        );
        p5.pop();
      }

      stackArray.forEach((e) => {
        this.sides[e].color = "blue";
        this.sides[e].textColor = "white";
      });

      this.sides[i].stackEditRender(p5, i, wallTrait, stackArray);
    }
  };

  this.stackEditClicked = (p5, wallTrait, setStack) => {
    for (let i = 0; i < this.sides.length; i++) {
      let x1 = p5.mouseX;
      let y1 = p5.mouseY;

      let r = p5.dist(
        this.sides[i].x1,
        this.sides[i].y1,
        this.sides[i].x5,
        this.sides[i].y5
      );

      let d1 = p5.dist(this.sides[i].x1, this.sides[i].y1, x1, y1);

      let d2 = p5.dist(this.sides[i].x5, this.sides[i].y5, x1, y1);

      if (d2 < r && d1 < r) {
        setStack(wallTrait[i].id);
      }
    }
  };

  this.travelClicked = (p5, setTabIndex) => {
    for (let i = 0; i < this.sides.length; i++) {
      let x1 = p5.mouseX;
      let y1 = p5.mouseY;

      let r = p5.dist(
        this.sides[i].x1,
        this.sides[i].y1,
        this.sides[i].x5,
        this.sides[i].y5
      );

      let d1 = p5.dist(this.sides[i].x1, this.sides[i].y1, x1, y1);

      let d2 = p5.dist(this.sides[i].x5, this.sides[i].y5, x1, y1);

      if (d2 < r && d1 < r) {
        if (i < wallTrait.length) {
          setTabIndex(wallTrait[i].id + 1);
        }
      }
    }
  };

  this.turn = (p5, turn) => {
    let increment = (360 / trait.size) * turn;
    this.sides = [];
    for (let a = 0; a < 360; a += 360 / trait.size) {
      if (increment <= 360) {
        increment += 360 / trait.size;
      } else {
        increment = (360 / trait.size) * 2;
      }
      p5.angleMode(p5.DEGREES);
      let side = new Side(
        p5,
        trait,
        this.xcenter,
        this.margin,
        this.size,
        depth,
        increment,
        textSize
      );
      this.sides.push(side);
    }
  };

  this.clicked = (p5) => {
    for (let i = 0; i < wallTrait.length; i++) {
      const pixels = wallTrait[i].pixels;
      let x1 = p5.mouseX;
      let y1 = p5.mouseY;

      let r = p5.dist(
        this.sides[i].x1,
        this.sides[i].y1,
        this.sides[i].x5,
        this.sides[i].y5
      );

      let d1 = p5.dist(this.sides[i].x1, this.sides[i].y1, x1, y1);

      let d2 = p5.dist(this.sides[i].x5, this.sides[i].y5, x1, y1);

      if (d2 < r && d1 < r) {
        let windows = 0;
        let doors = 0;
        let frenchDoors = [null, null, null];

        if (
          wallTrait[i].windows < 2 &&
          wallTrait[i].doors < 1 &&
          wallTrait[i].frenchDoor === null
        ) {
          windows = wallTrait[i].windows + 1;
        } else if (wallTrait[i].doors < 1 && wallTrait[i].frenchDoor === null) {
          doors = wallTrait[i].doors + 1 * pixels;
        } else if (wallTrait[i].frenchDoor === null) {
          frenchDoors[0] = "left";
          frenchDoors[1] = "center";
          frenchDoors[2] = "right";
        }
        let windowChange = {
          target: {
            name: "windows",
            value: windows,
            form: {
              id: i,
            },
            parentElement: {
              id: null,
            },
          },
        };
        let doorChange = {
          target: {
            name: "doors",
            value: doors,
            form: {
              id: i,
            },
            parentElement: {
              id: null,
            },
          },
        };
        for (let k = 0; k < 3; k++) {
          let frenchChange = {
            target: {
              name: "frenchDoor",
              value: frenchDoors[k],
              form: {
                id:
                  (((i + (k - 1)) % this.sides.length) + this.sides.length) %
                  this.sides.length,
              },
              parentElement: {
                id: null,
              },
            },
          };
          handleTraitChange(frenchChange);
        }
        handleTraitChange(windowChange);
        handleTraitChange(doorChange);
      }
    }
  };

  this.hover = (p5, color) => {
    for (let i = 0; i < this.sides.length; i++) {
      let x1 = p5.mouseX;
      let y1 = p5.mouseY;

      let r = p5.dist(
        this.sides[i].x1,
        this.sides[i].y1,
        this.sides[i].x5,
        this.sides[i].y5
      );

      let d1 = p5.dist(this.sides[i].x1, this.sides[i].y1, x1, y1);

      let d2 = p5.dist(this.sides[i].x5, this.sides[i].y5, x1, y1);

      if (d2 < r && d1 < r) {
        this.sides[i].color = color;
        p5.cursor("pointer");
      }
    }
  };
}
